<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0">
            <div class="h2">Новые мероприятия по выпуску</div>

            <div class="mb-3" v-if="raid">
                <small class="text-secondary">{{ raid.objectLabel() }} по заявке №{{ requestId }}</small>
            </div>

            <div :key="getUpdateKey">

                <div v-if="requestId && isCompleted()">
                    <span class="h4 mb-3">
                        <span class="mr-2">Все мероприятия созданы</span>
                        <b-icon icon="check" variant="success"/>
                    </span>

                    <b-row class="p-0 m-0 mb-4">
                        <b-col class="p-0 pt-3">
                            <div v-for="(animal, i) in animals" :key="i" class="d-flex align-items-start p-1 mb-3">
                                <animal-link :animal="animal" />
                            </div>
                        </b-col>
                    </b-row>

                        <div>
                            <b-link :to="{ name: 'requestsDetail', params: { id: requestId } }">
                                <b-icon icon="arrow-left" class="mr-2"/>
                                <span>Вернуться к заявке</span>
                            </b-link>
                        </div>
                </div>

                <div v-if="request && !isCompleted()">
                    <b-row class="p-0 m-0 mb-4">
                        <b-col class="border-bottom p-0 pt-3 pb-3">
                            <div class="h4 mb-2">Исполнитель</div>
                            <common-event :kind="eventKind"
                                          :editable="true"
                                          :keeping-contract="request.contractObject"
                                          ref="commonEvent"
                                          class="mb-2" />
                        </b-col>
                    </b-row>

                    <b-row class="p-0 m-0 mb-4">
                        <b-col class="border-bottom p-0 pt-1 pb-1">
                            <div class="h4 mb-2">Животные</div>
                            <div v-for="(animal, i) in animals" :key="i" class="d-flex align-items-start p-1 mb-3">
                                <animal-link :animal="animal" />
                            </div>
                        </b-col>
                    </b-row>


                    <div class="h4 mb-3">Подтверждение выпуска</div>
                    <b-row class="mb-5">

                        <gallery :label="'Фото'"
                                 :root-api-url="galleryUrl"
                                 :can-update="hasAbilityToUpdateAttachments"
                                 :max-files="6"
                                 :accepts="photoGalleryAccepts"
                                 :upload-immediately="true"
                                 :existing="true"
                                 :max-size="25"
                                 :kind="1"
                                 @files-uploaded="onFilesUploaded($event, 1)"
                                 ref="photoGallery"
                                 class="col-xs-12 col-sm-12 col-md-6">
                        </gallery>

                        <gallery :label="'Видео'"
                                 :root-api-url="galleryUrl"
                                 :can-update="hasAbilityToUpdateAttachments"
                                 :max-files="1"
                                 :accepts="videoGalleryAccepts"
                                 :upload-immediately="true"
                                 :existing="true"
                                 :max-size="30"
                                 :kind="3"
                                 @files-uploaded="onFilesUploaded($event, 3)"
                                 ref="videoGallery"
                                 class="col-xs-12 col-sm-12 col-md-6">
                        </gallery>
                    </b-row>

                    <div class="d-flex flex-column">
                        <div class="flex-grow-0 mb-3">
                            <b-button variant="primary" @click="onCreateEvents">Создать</b-button>
                        </div>
                        <div class="flex-grow-1">
                            <b-link :to="{ name: 'requestsDetail', params: { id: requestId } }">
                                <b-icon icon="arrow-left" class="mr-2"/>
                                <span>Вернуться к заявке</span>
                            </b-link>
                        </div>

                    </div>


                </div>
            </div>

        </b-card>
    </div>
</template>

<script>
import CommonEvent from "@/pages/AppPages/Events/CommonEvent";
import {eventFactory, EventKind} from "@/pages/AppPages/Events/event";
import api from "@/api";
import httpClient from "@/http";
import {Request} from "@/pages/AppPages/Requests/request";
import AnimalAvatar from "@/pages/AppPages/Animals/AnimalAvatar";
import Gallery from "@/components/Files/Gallery";
import {mapGetters} from "vuex";
import {Raid} from "@/pages/AppPages/Raids/raid";
import qs from 'qs';
import AnimalLink from "@/pages/AppPages/Animals/AnimalLink.vue";

export default {
    name: "HabitatBulkCreate",
    components: {AnimalLink, Gallery, AnimalAvatar, CommonEvent},
    data() {
        return {
            eventKind: EventKind.RETURN_TO_HABITAT,
            raid: null,
            request: null,
            animals: [],
            createdEvents: {},
            uploadedGalleryAttachmentIds: [],
            uploadedVideoAttachmentId: null,
            updateKey: new Date().getTime()
        }
    },
    computed: {
        ...mapGetters(['ability']),
        requestId() {
            if (this.raid) {
                return this.raid.request;
            }
        },
        raidId() {
            return this.$route.params.raidId;
        },
        galleryUrl() {
            const raidUrl = api.raids.default.detail(this.raidId)
            return `${api.raids.attachments.list(raidUrl)}`;
        },
        photoGalleryAccepts() { return ['image/jpeg', 'image/png', 'image/tiff'] },
        videoGalleryAccepts() { return ['video/mpeg', 'video/mp4'] },
        hasAbilityToUpdateAttachments() {
            return this.ability.can('update', this.raid)
        },
        getUpdateKey() {
            return this.updateKey
        }
    },
    methods: {
        async createEvent(animal, data) {
            const endpoint = api.events.default.list();
            const response = await httpClient.post(endpoint, data).catch((reason) => {
                if (reason.response) {
                    throw new Error(reason.response.data['non_field_errors']);
                }
            });
            const objectClass = eventFactory(EventKind.RETURN_TO_HABITAT);
            let newEvent = new objectClass();
            newEvent.applyData(response.data);
            return newEvent
        },
        async onCreateEvents() {
            const vm = this;
            const animalsForEvents = this.animals.filter(x => vm.createdEvents[x.id] === undefined)
            const eventData = this.$refs.commonEvent.prepareData();
            let attributes = { releaseRequest: this.requestId, releaseRaid: this.raidId }
            if (this.uploadedGalleryAttachmentIds.length) {
                attributes.images = this.uploadedGalleryAttachmentIds
            }
            if(this.uploadedVideoAttachmentId) {
                attributes.video = this.uploadedVideoAttachmentId
            }
            for (const animal of animalsForEvents) {
                const data = {...eventData, attributes: attributes,
                    animal: animal.id,  request: animal['pack_request_id']}
                const newEvent = await this.createEvent(animal, data).catch((error) => {
                    vm.$bvToast.toast(error.message, { variant: 'danger', noCloseButton: true, solid: true })
                })
                if (newEvent) {
                    vm.createdEvents[animal.id] = newEvent;
                    vm.uploadedGalleryAttachmentIds = [];
                    vm.uploadedVideoAttachmentId = null;
                    vm.$bvToast.toast(`Мероприятие №${newEvent.id} по выпуску создано успешно`, { variant: 'success', noCloseButton: true, solid: true })
                }
            }
            if (this.isCompleted()) {
                vm.updateKey = new Date().getTime();
            }
        },
        isCompleted() {
            return Object.keys(this.createdEvents).length === this.animals.length
        },
        onFilesUploaded(uploadedIds, kind) {
            if (kind === 1) {
                this.uploadedGalleryAttachmentIds = uploadedIds.ids;
            }
            if (kind === 3 && uploadedIds.ids !== undefined && uploadedIds.ids.length > 0) {
                this.uploadedVideoAttachmentId = uploadedIds.ids[0]
            }
        },
        fetchRequest() {
            const vm = this;
            return new Promise((resolve, reject) => {
                const requestUrl = api.requests.default.detail(vm.requestId);
                httpClient.get(requestUrl).then(response => {
                    vm.request = new Request();
                    vm.request.applyData(response.data);
                    resolve();
                }).catch(reason => {
                    vm.$bvToast.toast(reason, { title: 'Ошибка при получении информации о заявке с сервера', variant: 'danger'})
                    reject();
                });
            })
        },
        fetchRaid() {
            const vm = this;
            return new Promise((resolve, reject) => {
                const raidUrl = api.raids.default.detail(vm.raidId);
                httpClient.get(raidUrl).then(response => {
                    vm.raid = new Raid();
                    vm.raid.applyData(response.data);
                    resolve();
                }).catch(reason => {
                    vm.$bvToast.toast(reason, { title: 'Ошибка при получении информации о рейде с сервера', variant: 'danger'})
                    reject();
                });
            })
        },
        fetchAnimals() {
            const vm = this;
            return new Promise((resolve, reject) => {
                const animalIds = vm.$route.query['animal'];
                const animalsUrl = api.animals.default.list();
                httpClient.get(animalsUrl,
                    {
                        params: {'animal_id': animalIds},
                        paramsSerializer: params => { return qs.stringify(params, {arrayFormat: 'repeat'}) }})
                    .then((response) => {
                        const data = response.data;
                        for (const animalData of data.results)  {
                            vm.animals.push(animalData)
                        }
                        resolve()
                    }).
                    catch((reason) => {
                        reject()
                    })
            })
        }
    },
    mounted() {
        const vm = this;
        vm.fetchRaid()
            .then(() => {
                return vm.fetchAnimals()
            }).then(() => {
                return vm.fetchRequest()
            })
    }
}
</script>

<style scoped>

</style>